export default {
  title: 'Aperçu',
  table_title: 'Réservations',
  filters: {
    card_title: 'Filtres',
    today: "Aujourd'hui",
    upcoming: 'À venir',
    past: 'Passées',
    all: 'Toutes',
    all_dates: 'Toutes les dates',
    pending: 'En attente de confirmation',
    canceled: 'Annulée',
    removed: 'Supprimée',
    date_label: 'Date :',
    status_label: 'Statut :',
    source_label: 'Source :',
    source_website: 'Site web',
    source_google: 'Google',
    search_label: 'Recherche :',
    search_placeholder: 'Rechercher par prénom ou nom',
    custom_date_tooltip: 'Choisir une date précise',
    active_label: 'Filtres actifs :',
    clear_all: 'Tout effacer',
  },
  tooltips: {
    total_reservations: 'Total des réservations',
    total_guests: 'Total des convives',
    refresh: 'Actualiser',
  },
  empty: {
    default: "Aucune réservation pour l'instant.",
    filtered: 'Aucune réservation ne correspond aux filtres.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Date / heure',
    customer: 'Client',
    source: 'Source',
    guests: 'Convives',
    status: 'Statut',
    created_at: 'Créée le',
  },
  status: {
    confirmed: 'Confirmée',
    pending: "En attente d'approbation",
    canceled: 'Annulée',
    rejected: 'Rejetée',
    removed: 'Supprimée',
  },
  buttons: {
    details: 'Détails',
    add_reservation: 'Ajouter une réservation',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
